module.exports = __webpack_public_path__ + "static/media/Minus.fecb0b48.png";